"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const storage_1 = require("../lib/storage");
const lang_1 = require("../lib/lang");
const ucParamAjaxHelper_1 = require("../lib/ucParamAjaxHelper");
const share_1 = require("../lib/share");
const BOTTOMcOMPACT_KEY = '/story';
const LIKE_MAX_COUNT = 100;
const LIKE_MAX_SIZE = 1000;
class BottomCompactStore {
    constructor(config) {
        this.config = config;
        this.likeCount = config.likeCount;
        this.dislikeCount = config.dislikeCount;
        this.storage = new storage_1.LocalStorage(BOTTOMcOMPACT_KEY);
        this.shareApps = [];
        const likeInfo = this.findLike(this.getLikeArray('like'));
        this.isLike = !!likeInfo;
        if (this.isLike && this.likeCount < likeInfo.count) {
            this.likeCount = likeInfo.count;
        }
        this.isDislike = !!this.findLike(this.getLikeArray('dislike'));
        this.showDislikeOption = false;
        this.dislikeOptons = [];
        const dislikeOptions = lang_1.__('widgetDislikeOptions.options');
        dislikeOptions && Array.isArray(dislikeOptions) && dislikeOptions.forEach((item) => {
            this.dislikeOptons.push(item);
        });
        this.initShareApp();
    }
    getLikeArray(storageKey) {
        return this.storage.getItem(storageKey) || [];
    }
    findLike(likeArray) {
        const findItem = likeArray.find((item) => {
            return item.id === this.config.itemId;
        });
        return findItem;
    }
    initShareApp() {
        share_1.default.getShareApps().then((data) => {
            this.shareApps = data;
        });
    }
    shareTo(item) {
        share_1.default.shareTo(item);
    }
    toggleLike() {
        const type = 'like';
        setTimeout(() => {
            this.cleanOldLike(type);
        });
        const likeArray = this.getLikeArray(type);
        let findItem = this.findLike(likeArray);
        if (!this.isLike) {
            this.isLike = true;
            this.likeCount++;
            findItem = {
                id: this.config.itemId,
                count: this.likeCount,
            };
            likeArray.push(findItem);
            this.storage.setItem(type, likeArray);
            ucParamAjaxHelper_1.default.postJsonWithCommonParams(`@{apiHost}/v2/api/like/like/${this.config.itemId}`, {});
            return 1;
        }
        else if (findItem) {
            this.isLike = false;
            this.likeCount--;
            findItem.count = this.likeCount;
            const findIndex = likeArray.indexOf(findItem);
            if (findIndex >= 0) {
                likeArray.splice(findIndex, 1);
            }
            this.storage.setItem(type, likeArray);
            ucParamAjaxHelper_1.default.postJsonWithCommonParams(`@{apiHost}/v2/api/like/dislike/${this.config.itemId}`, {});
            return -1;
        }
        return 0;
    }
    addDisLike() {
        const type = 'dislike';
        setTimeout(() => {
            this.cleanOldLike(type);
        });
        const likeArray = this.getLikeArray(type);
        let findItem = this.findLike(likeArray);
        if (!this.isDislike) {
            this.isDislike = true;
            this.dislikeCount++;
            findItem = {
                id: this.config.itemId,
                count: this.dislikeCount,
            };
            likeArray.push(findItem);
            this.storage.setItem(type, likeArray);
            return 1;
        }
        return 0;
    }
    cleanOldLike(storageKey) {
        const likeArray = this.getLikeArray(storageKey);
        // 限制单条新闻评论点赞数量和体积的大小
        let likeKeysJson = JSON.stringify(likeArray);
        let change = false;
        while (likeArray.length > LIKE_MAX_COUNT || likeKeysJson.length > LIKE_MAX_SIZE) {
            likeArray.shift();
            likeKeysJson = JSON.stringify(likeArray);
            change = true;
        }
        change && this.storage.setItem(storageKey, likeArray);
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], BottomCompactStore.prototype, "likeCount", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], BottomCompactStore.prototype, "dislikeCount", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], BottomCompactStore.prototype, "shareApps", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], BottomCompactStore.prototype, "isLike", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], BottomCompactStore.prototype, "isDislike", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], BottomCompactStore.prototype, "showDislikeOption", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], BottomCompactStore.prototype, "dislikeOptons", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], BottomCompactStore.prototype, "initShareApp", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], BottomCompactStore.prototype, "toggleLike", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], BottomCompactStore.prototype, "addDisLike", null);
exports.default = BottomCompactStore;
//# sourceMappingURL=data:application/json;base64,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